module.exports = __webpack_public_path__ + "static/media/calendar.c2c1774d.svg";